import React from 'react';
import {css} from 'glamor';

let opacIn = css.keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
})

const imageStyles = css({
  animation: `${opacIn} 300ms`
});

class PreloadImage extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {};
  }

  componentDidMount() {
    this.preloadImage(this.props.src);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.src !== nextProps.src) {
      this.setState({src: null});
      setTimeout(() => this.preloadImage(nextProps.src), 100);
    }
  }

  componentWillUnmount() {
    if (this.imageLoadTimeout) {
      clearTimeout(this.imageLoadTimeout);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.src !== nextState.src;
  }

  preloadImage(imageSrc) {
    if (!imageSrc) {
      this.onImageError();
      return;
    }
    const image = new Image();
    image.onload = this.onImageLoad.bind(this, imageSrc);
    image.onerror = this.onImageError.bind(this);
    image.src = imageSrc;
    this.imageLoadTimeout = setTimeout(() => {
      this.onImageLoad(imageSrc);
    }, 1500);
  }

  render() {
    let {src, error, backgroundImage} = this.props;
    src = src || this.props.src;
    return (
        src ?
          backgroundImage ?
          <div {...imageStyles} {...this.props.styles} style={{backgroundImage: `url("${src}")`}}/> :
          <img {...imageStyles} {...this.props.styles} src={src} srcSet={this.props.srcSet}/> :
        <div className="preload-image pad"></div>
    );
  }

  onImageLoad(imageSrc) {
    this.setState({src: imageSrc});
    clearTimeout(this.imageLoadTimeout);
  }

  onImageError() {
    this.setState({error: true});
    clearTimeout(this.imageLoadTimeout);
  }
}

export default PreloadImage;


// WEBPACK FOOTER //
// ./src/components/PreloadImage.js